module.exports = __webpack_public_path__ + "img/gk1.2cce6e29.png";